export function ScreenTodayV2() {
  return (
    <div
      className="mfm-screen"
      data-mode="light"
      data-accent="burgundy"
      style={{
        width: "100%",
        height: "100%",
        padding: "108px 24px 24px",
        display: "flex",
        flexDirection: "column",
        gap: 28,
      }}
    >
      <div>
        <div className="eyebrow">Tomorrow · Sunday</div>
        <div
          className="serif"
          style={{
            fontSize: 56,
            lineHeight: 0.95,
            letterSpacing: "-0.025em",
            color: "var(--accent)",
            marginTop: 10,
          }}
        >
          Twenty
          <br />
          miles.
        </div>
        <div
          style={{
            fontFamily: "var(--display)",
            fontStyle: "italic",
            fontSize: 17,
            lineHeight: 1.4,
            color: "var(--text-2)",
            maxWidth: 280,
            marginTop: 14,
          }}
        >
          The longest run of your plan. We&apos;ve been building toward this since week one.
        </div>
      </div>

      <div
        style={{
          borderTop: "0.5px solid var(--hairline)",
          borderBottom: "0.5px solid var(--hairline)",
          padding: "16px 0",
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gap: 4,
        }}
      >
        <div>
          <div className="eyebrow" style={{ fontSize: 10 }}>
            Target pace
          </div>
          <div className="serif tnum" style={{ fontSize: 22, color: "var(--text)", marginTop: 4 }}>
            10:42
          </div>
        </div>
        <div>
          <div className="eyebrow" style={{ fontSize: 10 }}>
            Duration
          </div>
          <div className="serif tnum" style={{ fontSize: 22, color: "var(--text)", marginTop: 4 }}>
            3h 34m
          </div>
        </div>
        <div>
          <div className="eyebrow" style={{ fontSize: 10 }}>
            Effort
          </div>
          <div className="serif" style={{ fontSize: 22, color: "var(--text)", marginTop: 4 }}>
            Easy
          </div>
        </div>
      </div>

      <div
        style={{
          background: "var(--surface)",
          borderRadius: 14,
          padding: "18px 20px",
          display: "flex",
          flexDirection: "column",
          gap: 8,
        }}
      >
        <div className="eyebrow" style={{ fontSize: 10 }}>
          From your coach
        </div>
        <div
          style={{
            fontFamily: "var(--display)",
            fontStyle: "italic",
            fontSize: 17,
            lineHeight: 1.4,
            color: "var(--text)",
          }}
        >
          Eat the night before. Set out two bottles. Start slow — the first hour is rehearsal.
        </div>
      </div>

      <div style={{ marginTop: "auto", display: "flex", flexDirection: "column", gap: 10 }}>
        <button type="button" className="mfm-btn-primary">
          View the route
        </button>
        <div
          style={{
            textAlign: "center",
            fontFamily: "var(--ui)",
            fontSize: 12,
            color: "var(--text-3)",
          }}
        >
          Trust the plan.
        </div>
      </div>
    </div>
  );
}
